export default __webpack_public_path__ + "static/media/salon.5ee5ce40.png";